import { graphql } from '@/generated/gql';

export const NEGOTIATION_DEMAND_UPDATE_PRIORITY_MUTATION = graphql(/* GraphQL */ `
  mutation TesseractNegotiationDemandDetailUpdatePriority($id: UUID!, $data: TsrctDemandPriorityUpdateInput!) {
    tesseract {
      demand(id: $id) {
        priority {
          update(data: $data) {
            id
            priority
          }
        }
      }
    }
  }
`);
